(function(wnd){
    function FormHandler(container, params) {
        try {
            if (!container) {
                throw 'Container is required!';
            }

            this.container = container;

            if (params) {
                this.setParams(params);
            }

            this.init();
        } catch (error) {
            console.error(error);
        }
    }

    FormHandler.prototype = {
        container: undefined,
        form: undefined,
        sendedForm: false,
        type: '',
        init: function() {
            this.setElements();
            this.addDOMEvents();
        },
        setElements: function() {
            this.form = this.container.find('form');
            this.button = this.container.find('[data-purpose="send-button"]');
        },
        addDOMEvents: function() {
            var _self = this;

            this.form.find('input, textarea').on('blur', function () {
                var value = $(this).val();
                if (value.trim() !== '') {
                    $(this).addClass('has-value');
                } else {
                    $(this).removeClass('has-value');
                }
            });

            this.form.find('.has-dependency').on('change', function () {
               _self.checkDependedGroupVisibility($(this).attr('name'), $(this).val()); 
            });

            this.button.click(function(e){
                e.preventDefault();
                _self.sendForm();
            });

            this.form.submit(function(e){
                e.preventDefault();
            });
        },
        setParams: function(params) {
            if (params.type) this.setType(params.type);
        },
        setType: function(type) {
            this.type = type;
        },
        checkDependedGroupVisibility: function (field, value) {
            this.form.find('[data-depends-on]').each(function () {
                var group = $(this);
                var fields = group.data('depends-on');
                if (!fields) {
                    return;
                }

                var options = fields.split('|');
                for (var i = 0; i < options.length; i++) {
                    var parts = options[i].split('=');
                    if (field !== parts[0]) {
                        continue;
                    }

                    if (value === parts[1]) {
                        group.removeClass('hidden');
                        group.find('input').removeAttr('disabled');
                    } else {
                        group.addClass('hidden');
                        group.find('input').attr('disabled', true);
                    }
                    
                }
            });
        },
        sendForm: function() {
            if (!this.sendedForm) {
                var _self = this;
                this.sendedForm = true;

                $.ajax({
                    url: this.form.attr('action'),
                    dataType: 'json',
                    type:'post',
                    data: this.form.serialize(),
                    beforeSend: function() {
                        _self.form.find('.has-error').removeClass('has-error');
                        _self.form.find('.error-content').html('');
                        _self.form.find('.error-content').addClass('empty');
                    },
                    success: function(response) {
                        if (response.success) {
                            _self.confirmSubscribe();
                        } else {
                            $.each(response.errors, function(key, msg) {
                                _self.form.find('[name="'+key+'"]').addClass('has-error');

                                if (msg.trim() != '') {
                                    var errorContent = _self.form.find('[data-purpose="error-content"][data-field="'+key+'"]');
                                    if (errorContent && errorContent.length > 0) {
                                        errorContent.html(msg);
                                        errorContent.removeClass('empty');
                                    }
                                }
                            });
                        }
                    },
                    complete: function() {
                        setTimeout(function(){
                            _self.sendedForm = false;
                        }, 500);
                    }
                });
            }
        },
        confirmSubscribe: function() {
            this.form.find('.field').val('');
            this.form.find('[type="checkbox"]').prop('checked', false);
            this.container.addClass('success-sent');
        }
    };

    wnd.FormHandler = FormHandler;
})(window);
